import React from 'react'
import { MessageSquare } from 'lucide-react'

import type { IFeedbackButtonProps } from './FeedbackButton.types'
import * as S from './FeedbackButton.styles'

export function FeedbackButton({ onClick, isMobile = false }: IFeedbackButtonProps) {
    return (
        <S.StyledFeedbackButton onClick={onClick} color="transparent" size={isMobile ? 'small' : 'medium'}>
            <MessageSquare className="h-4 w-4" />
            {!isMobile && 'Give Feedback'}
        </S.StyledFeedbackButton>
    )
}
